<template>
  <div>
    <div class="text-left">
      <b-col lg="12" md="3" class="text-left">
        <b-button pill variant="info" class="col-lg-4">بازگشت</b-button>
      </b-col>
    </div>

    <form  @submit.prevent="onSubmit">
      <b-row>
        <b-col lg="6" md="12">
          <form-group :validations="$v.form.form_name">
              <div slot-scope="{ errors, invalid }">
            <label for="" class="mt-3"> نام </label>
            <b-form-input v-model="form.form_name"></b-form-input>
            <form-errors-manager class="float-right" :errors="errors" />
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" md="12">
          <form-group :validations="$v.form.public_name">
              <div slot-scope="{ errors, invalid }">
            <label for="" class="mt-3">نام عمومی </label>
            <b-form-input v-model="form.public_name" ></b-form-input>
              <form-errors-manager class="float-right" :errors="errors" />
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" md="12">
          <form-group :validations="$v.form.category">
              <div slot-scope="{ errors, invalid }">
            <label for="" class="mt-4"> دسته بندی</label>
            <select class="custom-select" v-model="form.category">
                <option value="">
                لطفا یک دسته بندی را انتخاب کنید
              </option >
              <option v-for="category in flatMenu(categories)">
                {{ category.name }}
              </option>
            </select>
            <form-errors-manager class="float-right" :errors="errors" />
            </div>
          </form-group>
        </b-col>


      
         <b-col lg="6" md="12">
          <form-group :validations="$v.form.validation">
              <div slot-scope="{ errors, invalid }">
            <label for="" class="mt-4"> اعتبار سنجی</label>
            
            <b-form-input v-model="form.validation" ></b-form-input>
              <form-errors-manager class="float-right" :errors="errors" />
            </div>
          </form-group>
        </b-col>

      </b-row>

      <b-col class="text-center">
        <b-btn variant="info" pill class="col-lg-8 my-5" type="submit">
          ثبت
        </b-btn>
      </b-col>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { flatMenu } from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Menu";
import { required } from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";

export default {

  components: { FormGroup, FormErrorsManager },
  data() {
    return {


        form: {
        form_name: "",
        public_name: "",
        category: "",
        validation:"",
      },
    };
  },
  validations: {
    form: {
      form_name: { required },
      public_name: { required },
      category: { required },
      validation:{ required },
    },
  },

  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
    }),
  },
  methods: {
    flatMenu,
  
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      console.log("in function");
      if (this.invalid()) {
        console.log("in");
      }
    },
  
  },
  async mounted() {
    await this.$store.dispatch("Category/getCategories");
  },
};
</script>
